/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '../../assets/css/bootstrap.min.css.shim.ngstyle';
import * as import1 from './scss/checkout.css.shim.ngstyle';
import * as import2 from './scss/aboutus.css.shim.ngstyle';
import * as import3 from './scss/buttons.css.shim.ngstyle';
import * as import4 from './scss/dedicated-servers-configurator.css.shim.ngstyle';
import * as import5 from './scss/header-configurator.css.shim.ngstyle';
import * as import6 from './scss/mixins.css.shim.ngstyle';
import * as import7 from './scss/services.css.shim.ngstyle';
import * as import8 from '@angular/core';
import * as import9 from '../../../app/checkout/checkout-order-accepted.component';
import * as import10 from '../../../app/services/local-storage.service';
import * as import11 from '@angular/router';
const styles_CheckoutOrderAcceptedComponent:any[] = [
  import0.styles,
  import1.styles,
  import2.styles,
  import3.styles,
  import4.styles,
  import5.styles,
  import6.styles,
  import7.styles
]
;
export const RenderType_CheckoutOrderAcceptedComponent:import8.RendererType2 = import8.ɵcrt({
  encapsulation: 0,
  styles: styles_CheckoutOrderAcceptedComponent,
  data: {}
}
);
export function View_CheckoutOrderAcceptedComponent_0(l:any):import8.ɵViewDefinition {
  return import8.ɵvid(0,[
    (l()(),import8.ɵeld(0,(null as any),(null as any),37,'div',[
      [
        'class',
        'page-wrapper'
      ]
      ,
      [
        'style',
        'width: 100vw'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n        '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),34,'section',[[
        'class',
        'configuration-container checkout-configuration-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n             '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),31,'div',[[
        'class',
        'container checkout-payments'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n                '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),28,'div',[[
        'class',
        'row choose-payment-row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n                    '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'col-lg-12 col-md-12 col-sm-12'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n                        '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['Dziękujemy za złożenie zamówienia'])),
    (l()(),import8.ɵted((null as any),['\n                        '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['Pracownik BOK skontaktuje się z Państwem w ciągu jednego dnia roboczego od złożenia zamówienia.'])),
    (l()(),import8.ɵted((null as any),['\n                        '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),7,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['W razie pytań prosimy o kontakt mailowy na adres '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        'mailto:bok@dataspace.pl'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['bok@dataspace.pl'])),
    (l()(),import8.ɵted((null as any),[' lub \n                            telefoniczny pod numerem '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),1,'a',[[
        'href',
        'tel:+48566577178'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['+48 56 657 71 78'])),
    (l()(),import8.ɵted((null as any),['.'])),
    (l()(),import8.ɵted((null as any),['\n                    '])),
    (l()(),import8.ɵted((null as any),['\n                    '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'col-lg-12 col-md-12 col-sm-12 text-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n                        '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'text-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n                            '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),1,'a',[
      [
        'class',
        'button-small'
      ]
      ,
      [
        'href',
        '/'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['Przejdź do panelu'])),
    (l()(),import8.ɵted((null as any),['\n                        '])),
    (l()(),import8.ɵted((null as any),['\n                    '])),
    (l()(),import8.ɵted((null as any),['\n                '])),
    (l()(),import8.ɵted((null as any),['\n            '])),
    (l()(),import8.ɵted((null as any),['\n        '])),
    (l()(),import8.ɵted((null as any),['\n    '])),
    (l()(),import8.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(null as any));
}
function View_CheckoutOrderAcceptedComponent_Host_0(l:any):import8.ɵViewDefinition {
  return import8.ɵvid(0,[
    (l()(),import8.ɵeld(0,(null as any),(null as any),1,'app-checkout-order-accepted',([] as any[]),(null as any),(null as any),(null as any),View_CheckoutOrderAcceptedComponent_0,RenderType_CheckoutOrderAcceptedComponent)),
    import8.ɵdid(114688,(null as any),0,import9.CheckoutOrderAcceptedComponent,[
      import10.LocalStorageService,
      import11.Router
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const CheckoutOrderAcceptedComponentNgFactory:import8.ComponentFactory<import9.CheckoutOrderAcceptedComponent> = import8.ɵccf('app-checkout-order-accepted',import9.CheckoutOrderAcceptedComponent,View_CheckoutOrderAcceptedComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/checkout/checkout-order-accepted.component.ngfactory.ts